var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamond7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 1h-11.917l-6.083 7 12 15 12-14.917-6-7.083zm-10.498 9.576c-.366-1.197-1.303-2.134-2.501-2.5 1.196-.366 2.135-1.303 2.499-2.5.367 1.197 1.305 2.135 2.5 2.5-1.195.366-2.133 1.303-2.498 2.5zm3.499 4.5c-.293-.958-1.042-1.708-2.001-2 .957-.292 1.708-1.042 1.999-2 .294.958 1.043 1.708 2 2-.957.293-1.706 1.043-1.998 2zm4.499-3.576c-.511-1.676-1.823-2.988-3.5-3.499 1.677-.512 2.989-1.824 3.5-3.501.512 1.677 1.824 2.989 3.5 3.501-1.676.511-2.988 1.823-3.5 3.499z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond7);
export default __webpack_public_path__ + "static/media/diamond-7.02e82c573e699768f88e1f9e03c6adc4.svg";
export { ForwardRef as ReactComponent };